export const getCertificateStatusColour = (status) => {
    switch (status.toLowerCase()) {
        case 'active':
            return 'text-green-600';
        case 'expired':
        case 'failed':
            return 'text-red-600';
        default:
            return '';
    }
};

export const CERTIFICATE_STATUS = {
    ACTIVE: '1',
    EXPIRED: '2',
    REVOKED: '3',
    PENDING: '4',
    UNKNOWN: '5',
    UPLOADING: '6',
    UPLOADED: '7',
    FAILED: '8',
    SYSTEM: '9',
};

export const CERTIFICATE_IMPORT_EXPORT_TYPES = {
    PFX: '1',
    PEM: '2'
};

export const CERTIFICATE_IS_CA = {
    NO: '0',
    YES: '1'
}

export const CERTIFICATE_TYPES = {
    WEBSERVER: '1',
    CONTROLLER_MQTT: '2',
    SOFTWARE_MQTT: '3',
    MQTT_BROKER: '4' ,
    IDEMIA: '5',
    VINGCARD: '6'
};